// extracted by mini-css-extract-plugin
export var aircallIframe = "_m4-3";
export var fabContainer = "_m4-5";
export var fabRinging = "_m4-6";
export var loadingOverlay = "_m4-4";
export var pulse = "_m4-7";
export var widgetContent = "_m4-2";
export var widgetPanel = "_m4-0";
export var widgetPanelExpanded = "_m4-1";